<template>
  <div>
    <RightTitle title="会员充值"></RightTitle>
    <ChargeTab position="vip"></ChargeTab>

    <!-- 活动提示 -->
    <div class="uar_form" v-if="vipActive.status == 1">
      <blockquote class="quote_notice">
        <p class="blue">温馨提示：{{vipActive.act.description}}，本次活动截止时间：{{vipActive.act.endTime}}</p>
      </blockquote>
    </div>

    <!-- 表单 -->
    <div class="uar_form">
      <el-form ref="form" :model="form" label-width="80px" size="medium">
        <el-form-item label="选择金额">
          <el-radio-group v-model="form.money">
            <div class="azz_radio_group">
              <p v-for="(item, index) in chargeCardList" :key="index">
                <el-radio :label="item.price">
                  <span class="paddingRight">{{item.payPrice}}元</span>
                  <span class="deleleLine paddingRight" v-if="vipActive.status == 1">(原价{{item.price}}元)</span>
                  <span class="paddingRight">{{ item.name }}</span>
                </el-radio>
              </p>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="充值方式">
          <el-radio-group v-model="chargeType">
            <el-radio label="1">支付宝</el-radio>
            <el-radio label="2">微信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getForm">开始充值</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="uar_form">
      <blockquote class="quote_notice">
        <p class="blue">温馨提示：</p>
        <p>1.充值实时到账</p>
        <p>
          2.如果充值没有到账，可联系我们客服咨询！
          <a :href="customerUrl" target="_blank" class="blue">点击这里联系客服</a>
        </p>
      </blockquote>
    </div>

    <!-- 弹窗 -->
    <el-dialog title="充值提示" :visible.sync="dialogVisible" width="30%">
      <p>请在新打开的页面完成付款</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="paySuccess">已完成付款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 加载组件
import RightTitle from "../../components/RightTitle";
import ChargeTab from "../../components/ChargeTab";
// 加载api
import { vipChargeConfig } from "../../api/charge";
// 加载函数
import { urlEncode } from "../../utils/fn";
export default {
  name: "charge.vip",
  components: {
    RightTitle,
    ChargeTab
  },
  beforeRouteEnter(to, from, next) {
    vipChargeConfig().then(res => {
      next(vm => {
        vm.chargeCardList = res.data.vip;
        vm.vipActive = res.data.vipActive;
        vm.alipayUrl = res.data.youmiAlipay;
        vm.wechatPayUrl = res.data.youmiWechat;
        vm.customerUrl = res.data.customerUrl;
        vm.setDefaultMoney();
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    vipChargeConfig().then(res => {
      this.chargeCardList = res.data.vip;
      this.vipActive = res.data.vipActive;
      this.customerUrl = res.data.customerUrl;
      this.setDefaultMoney();
    });
    next();
  },
  data() {
    return {
      form: {
        money: 0
      },
      chargeCardList: [],
      alipayUrl: "",
      wechatPayUrl: "",
      dialogVisible: false,
      chargeType: "1",
      customerUrl: "",
      vipActive: {}
    };
  },
  methods: {
    getForm() {
      if (this.form.money <= 0) {
        this.$notify({
          title: "警告",
          message: "请选择金额",
          type: "warning"
        });
        return false;
      }
      let payTypeUrl = this.alipayUrl;
      if (this.chargeType == 2) {
        payTypeUrl = this.wechatPayUrl;
      }
      this.dialogVisible = true;
      let token = localStorage.getItem("token");
      let payUrl =
        payTypeUrl +
        "?token=" +
        urlEncode(token) +
        "&money=" +
        this.form.money * 100 +
        "&ct=vip";

      window.open(payUrl);
    },
    // 设置默认金额
    setDefaultMoney() {
      if (this.chargeCardList.length > 0) {
        this.chargeCardList.forEach(element => {
          if (element.default == 1) {
            this.form.money = element.price;
          }
        });
      }
    },
    paySuccess() {
      this.$router.push({ name: "charge.index" });
    }
  }
};
</script>

<style scoped>
</style>